// keys.ts — RQ cache keys for the tags suite. Private.

const TAGS_QUERY_KEY = {
  Root: 'tags',
} as const;

export const tagsKeys = {
  all: [TAGS_QUERY_KEY.Root] as const,
};
